{
	"four-simple-steps": "Fjögur einföld skref til þess að nota póstbox",
	"get-the-app": "Sækir appið",
	"login": "Innskráning",
	"pickup": "Sækir um allt land",
	"ship-products": "Sendir vörur í póstboxið",
	"simple-login": "Einföld innskráning"
}
